import highcharts from "highcharts";
import angular from "angular";

angular.module('clientDashboardApp').controller("AvgRankCtrl",
  function ($scope, $timeout, $location, $anchorScroll, rankingService, locationService, searchService) {
    $scope.locationSummaries = [];
    
    $scope.noteSettings = {type: "rankings", userInfo: $scope.userInfo,}

    const type = "rankings";
    // See RankingsController.exportRankingsCsv for available params.
    const reportParams = { reportDetail: "all" };
    $scope.allResults = searchService.withExportConfig(type, $scope.getRankingOptions(), reportParams);

    $scope.$watch(
      "searchConfig",
      function(newConfig, oldConfig) {
        $scope.allResults = searchService.withExportConfig(type, $scope.getRankingOptions(), reportParams);
      },
      true
    );

    $scope.selectedCell = null;
    $scope.isSelected = function (provider, keyword, localArea) {
      var localAreaStr = angular.isDefined(localArea) ? localArea : "";
      return $scope.selectedCell == provider + keyword + localAreaStr;
    };

    $scope.selectCell = function (provider, ranking, localArea) {
      if(!ranking.countByProvider[provider] || ranking.countByProvider[provider]==''){
        return;
      }

      delete $scope.rankingOptions.localArea;
      delete $scope.rankingSearchOptions.localArea;
      var localAreaStr = angular.isDefined(localArea) ? localArea : "";
      $scope.selectedCell = provider + ranking.keyword + localAreaStr;

      //Redraw graph
      var rankingOptions = $scope.rankingOptions;
      rankingOptions.providers = provider;
      rankingOptions.keyword = ranking.keyword;

      if(angular.isDefined(localArea)){
        rankingOptions.localArea = localArea;
      }

      rankingService.rankingHistory($scope.searchConfig.groupId, rankingOptions).then(function (historicData) {
        $scope.drilldown = true;
        drawDrilldownChart(historicData);

        $timeout(function () {
          var old = $location.hash();
          $location.hash("drillDownGraph");
          $anchorScroll();
          $location.hash(old);
        });
      });

      angular.extend($scope.rankingSearchOptions, rankingOptions);
      searchService.searchRankings($scope.rankingSearchOptions).then(updateListingsTable);
    };

    $scope.rankingSearchOptions = {limit: 10, sortField: "lastUpdatedDate", sortOrder: "DESC"};

    $scope.getRankingsSortIcon = function (column) {
      if ($scope.rankingSearchOptions.sortField === column) {
        if ($scope.rankingSearchOptions.sortOrder === 'ASC') {
          return 'fa-sort-up';
        } else {
          return 'fa-sort-down';
        }
      } else {
        return 'fa-sort';
      }
    };

    $scope.sortRankingsTable = function (sortColumn) {
      if ($scope.rankingSearchOptions.sortField === sortColumn) {
        if ($scope.rankingSearchOptions.sortOrder === 'ASC') {
          $scope.rankingSearchOptions.sortOrder = 'DESC';
        } else {
          $scope.rankingSearchOptions.sortOrder = 'ASC';
        }
      } else {
        $scope.rankingSearchOptions.sortField = sortColumn;
        $scope.rankingSearchOptions.sortOrder = 'DESC';
      }

      searchService.searchRankings($scope.rankingSearchOptions).then(updateListingsTable);
    };

    $scope.hasMoreResults = function (searchResult) {
      return searchResult.hasMoreResults();
    };

    $scope.hasAnyResults = function (searchResult) {
      return searchResult.hasAnyResults();
    };

    var updateListingsTable = function (searchResponse) {

      locationService.getLocationsInGroup($scope.searchConfig.groupId).then(
        locationMap => $scope.locationSummaries = _.mapObject(locationMap, location => locationService.formatLocation(location).summary)
      )

      $scope.searchResults = searchService.withExportConfig("rankings",null,{reportDetail:'drilldown'},searchResponse);
      $scope.loadingRankings = false;
    };

    $scope.loadingRankings = false;
    $scope.loadMoreResults = function (searchResult) {
      if (!searchResult || $scope.loadingRankings || !$scope.hasMoreResults(searchResult)) {
        //We are already awaiting results
        return;
      }
      $scope.loadingRankings = true;
      searchResult.loadMoreResults(10).then(updateListingsTable);
    };

    function drawSummaryChart(rankingByPeriod) {

        var avgRankings = [];

        //Order the months in ascending order
        var orderedMonths = Object.keys(rankingByPeriod).sort();
        angular.forEach(orderedMonths, function (date) {
          if (!date) {
            return;
          }
          var avgRanking = rankingByPeriod[date];
          var d = new Date(date);
          avgRankings.push([d.getTime(), Math.round(avgRanking * 100) / 100]);
        });

        var chart_div = document.querySelector('#ranking_summary_chart');

        var exportOptions = {
          buttons: {
            contextButton: {
              menuItems: [
                {
                  text: 'Export chart',
                  onclick: function () {
                    this.exportChart();
                  },
                  separator: false
                }
              ]
            }
          }
        };

        var chartConfig = {
          chart: {
            zoomType: 'xy',
            alignTicks: false
          },
          title: {
            text: null
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: 'Date'
            },
            labels: {
              step: 1
            },
            dataTimeLabelFormat: {
              month: '%b \'%y',
              year: '%Y'
            }
          },
          yAxis: [
            {
              title: {
                text: 'Average Ranking'
              },
              reversed: true,
              showFirstLabel: true,
              showLastLabel: true,
              floor: 1,
              ceiling: 50,
              minRange: 45
            }
          ],
          tooltip: {
            shared: false
          },
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'top',
            borderWidth: 0
          },
          series: [
            {
              name: 'Average Across Keywords',
              type: 'spline',
              data: avgRankings,
              marker: {
                enabled: false
              }
            }
          ],
          exporting: exportOptions,
          credits: {
            enabled: false
          }
        };

        /*
        if ($scope.rankingOptions.startDate) {
          var startDate = new Date($scope.rankingOptions.startDate);
          chartConfig.xAxis.min = startDate.getTime();
        }

        if ($scope.rankingOptions.endDate) {
          var endDate = new Date($scope.rankingOptions.endDate);
          chartConfig.xAxis.max = endDate.getTime();
        }
        */
        var chart = highcharts.chart(chart_div, chartConfig);

    }

    function drawDrilldownChart(historicData) {
      //Wrap in timeout since we want it to load after the scope is updated.
      $timeout(function () {
        var rankingByPeriod = historicData.rankingByPeriod;
        var keyword = historicData.keyword;
        var provider = historicData.provider;

        var avgRankings = [];

        //Order the months in ascending order
        var orderedMonths = Object.keys(rankingByPeriod).sort();
        angular.forEach(orderedMonths, function (date) {
          if (!date) {
            return;
          }
          var avgRanking = rankingByPeriod[date];
          var d = new Date(date);
          avgRankings.push([d.getTime(), Math.round(avgRanking * 100) / 100]);
        });

        var chart_div = document.querySelector('#ranking_by_period_chart');

        var exportOptions = {
          buttons: {
            contextButton: {
              menuItems: [
                {
                  text: 'Export chart',
                  onclick: function () {
                    this.exportChart();
                  },
                  separator: false
                }
              ]
            }
          }
        };

        var chartConfig = {
          chart: {
            zoomType: 'xy',
            alignTicks: false
          },
          title: {
            text: null
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: 'Date'
            },
            minTickInterval: 24 * 3600 * 1000 //Limit ticks to a minimum of 1 day
          },
          yAxis: [
            {
              title: {
                text: 'Average Ranking'
              },
              reversed: true,
              showFirstLabel: true,
              showLastLabel: true,
              floor: 1,
              ceiling: 100
            }
          ],
          tooltip: {
            shared: false
          },
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'top',
            borderWidth: 0
          },
          series: [
            {
              name: keyword + ' - ' + provider,
              type: 'spline',
              data: avgRankings,
              marker: {
                enabled: false
              }
            }
          ],
          exporting: exportOptions,
          credits: {
            enabled: false
          }
        };

        if ($scope.rankingOptions.startDate) {
          var startDate = new Date($scope.rankingOptions.startDate);
          chartConfig.xAxis.min = startDate.getTime();
        }

        if ($scope.rankingOptions.endDate) {
          var endDate = new Date($scope.rankingOptions.endDate);
          chartConfig.xAxis.max = endDate.getTime();
        }
        var chart = highcharts.chart(chart_div, chartConfig);
      })
    }

    $scope.$watch('rankingTimeline', function() {
      if ($scope.rankingTimeline && $scope.rankingTimeline !== undefined) {
        drawSummaryChart($scope.rankingTimeline.rankingByPeriod);
      }
    });

  });
